import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { HesburgerServicePromptnessTable } from '../../../common/monthlyWeeklyInfo/HesburgerServicePromptnessTable'
import { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import ImageOverlay from '../ImageOverlay/ImageOverlay'
import WeeklyInfoPage from '../WeeklyInfoPage'
import Images from '../components/Images'
import Links from '../components/Links'
import css from '../weeklyInfoPage.css'
import { fetchHesburgerEfficiencies } from '../weeklyInfoQueries'
import HesburgerEfficiencyFactorTable from './HesburgerEfficiencyFactorTable'
import { HesburgerSalesAndHoursTable } from './HesburgerSalesAndHoursTable'

interface HesburgerPageProps {
  user: User
}

interface HesburgerPageState {
  imageOverlayIsOpen: boolean
  selectedImage?: string
}

@withUser
class HesburgerPage extends React.Component<HesburgerPageProps, HesburgerPageState> {
  state: HesburgerPageState = {
    imageOverlayIsOpen: false,
    selectedImage: undefined,
  }

  selectImage = (imageContent: string) => {
    this.setState({
      selectedImage: imageContent,
      imageOverlayIsOpen: true,
    })
  }

  render() {
    const { user } = this.props
    const { imageOverlayIsOpen, selectedImage } = this.state
    return (
      <WeeklyInfoPage subject='Hesburger'>
        {({ stationId, date, companyId }) => {
          return (
            <div className={css.content}>
              <ImageOverlay
                isOpen={imageOverlayIsOpen}
                image={selectedImage}
                onClose={() =>
                  this.setState({
                    selectedImage: undefined,
                    imageOverlayIsOpen: false,
                  })
                }
              />
              <HesburgerServicePromptnessTable date={date} stationId={stationId} />
              <Query
                query={fetchHesburgerEfficiencies}
                variables={{
                  stationId,
                  date: date,
                }}
              >
                {({ data, error, loading, refetch }) => (
                  <Loader
                    {...{
                      error,
                      loading,
                    }}
                  >
                    <HesburgerEfficiencyFactorTable
                      efficiencyFactors={get(data, 'hesburgerEfficiencyFactor', null)}
                      efficiencyBoundary={get(data, 'hesburgerEfficiencyBoundary', null)}
                      date={date}
                      stationId={stationId}
                      refetch={refetch}
                    />
                  </Loader>
                )}
              </Query>
              <HesburgerSalesAndHoursTable date={date} stationId={stationId} />
              <Images
                stationId={stationId}
                selectImage={this.selectImage}
                user={user}
                imageType={'weekinfo_hesburger'}
              />
              <Links stationId={stationId} linkType={'weekinfo_hesburger'} companyId={companyId} />
            </div>
          )
        }}
      </WeeklyInfoPage>
    )
  }
}

export default HesburgerPage
